let language = {
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_ESHOPPER_SHIPPING_METHOD_TIP: `所使用运输方式：{{shipmentMethod}}（所选的送货方式不适用于该国家或地区。）`,
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_INVOICE_NULL_TIP: "拼单发票为空！",
    
    BULK_ORDER_CHECKOUT_STEP_SHIPPING_ADDRESS_NOT_SUPPORT: "此订单的送货地址不在{{appName}}的服务覆盖范围内。"
};

export { language }
